import { defaultIconProps, IconProps } from './IconProps';

export const IconSkipNext: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M5.83337 15L10.8334 10L5.83337 5" stroke={color} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.1666 5V15" stroke={color} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconSkipNext.defaultProps = defaultIconProps;
